import { Action } from '@ngrx/store';
import { Params } from '@angular/router/src/shared';
import { UrlParams } from '../model/url-params.model';

export const AUTHENTICATION_REQUEST =  '[Authentication] Request';
export const AUTHENTICATION_SUCCESS =  '[Authentication] Success';
export const AUTHENTICATION_ERROR =    '[Authentication] Error';

export class AuthenticationRequestAction implements Action {
    readonly type = AUTHENTICATION_REQUEST;

    constructor(public payload: AuthParams) {}
}

export class AuthenticationSuccessAction implements Action {
    readonly type = AUTHENTICATION_SUCCESS;

    constructor(public payload: UrlParams) { }
}

export class AuthenticationErrorAction implements Action {
    readonly type = AUTHENTICATION_ERROR;

    constructor(public payload: string) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = AuthenticationRequestAction
    | AuthenticationSuccessAction
    | AuthenticationErrorAction;


export class AuthParams {
    queryParams: Params;
    hashParams: Params;

    constructor(queryParams: Params, hashParams: Params) {
        this.queryParams = queryParams;
        this.hashParams = hashParams;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/actions/authentication.actions.ts